var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.894211,
    y: 0.138428,
    width: 43.4971,
    height: 43.4971,
    rx: 8.15571,
    fill: "#E0DCFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6039 12.3721C19.478 12.3721 18.5649 13.2844 18.5649 14.4107V15.0906H13.8074C12.6814 15.0906 11.7685 16.0035 11.7685 17.1296V28.0039C11.7685 29.1299 12.6814 30.0428 13.8074 30.0428H31.4782C32.6042 30.0428 33.5171 29.1299 33.5171 28.0039V17.1296C33.5171 16.0035 32.6042 15.0906 31.4782 15.0906H26.7207V14.4107C26.7207 13.2844 25.8076 12.3721 24.6817 12.3721H20.6039ZM20.6039 13.7314H24.6817C25.0573 13.7314 25.3614 14.0367 25.3614 14.4118V15.0906H19.9242V14.4107C19.9242 14.0355 20.2283 13.7314 20.6039 13.7314ZM23.1681 23.13L32.1578 20.7328V28.0039C32.1578 28.3792 31.8535 28.6835 31.4782 28.6835H13.8074C13.4321 28.6835 13.1278 28.3792 13.1278 28.0039V20.7328L22.1174 23.13C22.4617 23.2218 22.8239 23.2218 23.1681 23.13ZM13.8074 16.4499H31.4782C31.8535 16.4499 32.1578 16.7542 32.1578 17.1296V19.326L22.8179 21.8166C22.7032 21.8472 22.5824 21.8472 22.4677 21.8166L13.1278 19.326V17.1296C13.1278 16.7542 13.4321 16.4499 13.8074 16.4499Z",
    fill: "#624BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.320aff902ead0f3bde718515211c839b.svg";
export { ForwardRef as ReactComponent };